export class MenuItemsCss {
    static readonly MAIN_SECTION = 'mat-list-item mat-focus-indicator ng-star-inserted main-section';
    static readonly SUB_SECTION = 'mat-list-item mat-focus-indicator ng-star-inserted sub-section';
    static readonly MAIN_SECTION_OPEN   = 'mat-list-item mat-focus-indicator ng-star-inserted main-section open';
    static readonly SUB_SECTION_OPEN  = 'mat-list-item mat-focus-indicator ng-star-inserted sub-section open';
}